import { IdeationStatus, ModerationLabel, ModeratorTag } from './types'
import {
  createAssignedModeratorFilter,
  createChangedIdeationStatusAtFilter,
  createIdeationStatusFilter,
  createModerationLabelFilter,
  createModeratorTagFilter,
  createPinnedReplyFilter,
  createProductAreaFilter,
  createPublicTagFilter,
  createVotesFilter
} from './Filters'
import { AssignModerator, MarkAsSpam } from './BulkActions'
import {
  createAuthorColumn,
  createLastActivityColumn,
  createLastIdeationStatusChangeColumn,
  createProductAreasColumn,
  createPublicTagsColumn,
  createPublishDateColumn,
  createRepliesColumn,
  createTitleColumn,
  createVotesColumn
} from './Columns'
/* eslint-disable import/no-internal-modules */
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import globals from '@insided/deprecated-utils/globals'
import Overview from '@insided/deprecated-control/overview'
import { common } from '@insided/deprecated-preact-components/common'
import { createSeparator } from '@insided/deprecated-control/overview/filters/utils'

interface Props {
  moderationLabels: ModerationLabel[]
  moderatorTags: ModeratorTag[]
  ideationStatuses: IdeationStatus[]
  allProductAreas: []
}

const IdeationOverview = ({
  moderationLabels,
  moderatorTags,
  ideationStatuses,
  allProductAreas
}: Props) => {
  function getFilters() {
    const filters = [
      createIdeationStatusFilter(ideationStatuses, true),
      createProductAreaFilter(true),
      createModerationLabelFilter(moderationLabels),
      createModeratorTagFilter(moderatorTags),
      createAssignedModeratorFilter(),
      createSeparator(),
      createPublicTagFilter(),
      createVotesFilter(),
      createPinnedReplyFilter(),
      createChangedIdeationStatusAtFilter()
    ]

    if (!common.isModuleActive('productAreas')) {
      filters.splice(1, 1) // remove Product areas column if module is disabled
    }
    return filters
  }
  function getColumns() {
    const columns = [
      createTitleColumn(),
      createProductAreasColumn(allProductAreas),
      createVotesColumn(),
      createRepliesColumn(),
      createAuthorColumn(),
      createPublicTagsColumn(true),
      createPublishDateColumn(),
      createLastActivityColumn(),
      createLastIdeationStatusChangeColumn()
    ]
    if (!common.isModuleActive('productAreas')) {
      columns.splice(1, 1) // remove Product areas column if module is disabled
    }
    return columns
  }

  function getBulkActions() {
    return [AssignModerator, MarkAsSpam]
  }

  return (
    <Overview
      type='ideation'
      headerTitle='Ideas'
      withPagination={{
        page: 1,
        pageSize: 25
      }}
      withSorting={{
        lastActivityAt: 'desc'
      }}
      withFilters={getFilters()}
      withSearch
      searchPlaceholder='Search in title and content'
      withColumns
      rowId='publicId'
      model={getColumns()}
      endpoint='/idea/overview/topics'
      dataKey='topics'
      bulkActions={getBulkActions()}
      EmptyStateComponent={
        <EmptyPage
          img_src={`${globals('defaultCdn') as string}/images/empty_page.png`}
          header='No ideas found'
          text='Looks like no ideas have been shared in your community.'
          button={{ link: '/overview', text: 'Go back to overview' }}
        />
      }
      withCustomViews='idea'
    />
  )
}

export default IdeationOverview
